import { render } from "./NavView.vue?vue&type=template&id=0b310ac8&scoped=true&ts=true"
import script from "./NavView.vue?vue&type=script&lang=ts"
export * from "./NavView.vue?vue&type=script&lang=ts"

import "./NavView.vue?vue&type=style&index=0&id=0b310ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b310ac8"]])

export default __exports__